import { render, staticRenderFns } from "./signSuccess.vue?vue&type=template&id=5621654c&"
import script from "./signSuccess.vue?vue&type=script&lang=js&"
export * from "./signSuccess.vue?vue&type=script&lang=js&"
import style0 from "./signSuccess.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports